import React from 'react';

// Lightweight brand SVG icons for platforms not covered by lucide-react
const base = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'currentColor' };

export const TikTokIcon = (props) => (
  <svg {...base} {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 3c.4 2.3 1.9 4 4.5 4.2v3c-1.6.1-3.1-.4-4.5-1.2v6.4c0 3.4-2.7 5.9-6 5.9-3.1 0-5.6-2.4-5.6-5.5 0-3.2 2.6-5.6 5.8-5.4v3c-.3-.1-.7-.1-1-.1-1.4 0-2.5 1.1-2.5 2.5S8.8 18 10.2 18s2.4-1 2.4-2.6V3h3.9z" />
  </svg>
);

export const PinterestIcon = (props) => (
  <svg {...base} {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M12.3 2C6.9 2 4 5.5 4 9c0 1.7.9 3.7 2.4 4.4.2.1.4 0 .4-.2l.2-.9c.1-.2 0-.3-.1-.5-.5-.6-.8-1.4-.8-2.3 0-3 2.2-5.6 5.9-5.6 3.2 0 5 2 5 4.6 0 3.4-1.5 6.3-3.8 6.3-1.2 0-2.2-1-1.9-2.3.3-1.5 1-3.1 1-4.2 0-1-.5-1.8-1.6-1.8-1.3 0-2.3 1.3-2.3 3.1 0 1.1.4 1.9.4 1.9l-1.5 6.4c-.4 1.9-.1 4.2 0 4.4 0 .1.2.2.3.1.1-.1 1.8-2.2 2.4-4.3.2-.6.9-3.5.9-3.5.4.8 1.7 1.5 3 1.5 4 0 6.7-3.6 6.7-8.5C20.9 5.3 17.7 2 12.3 2z" />
  </svg>
);

export const ThreadsIcon = (props) => (
  <svg {...base} {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M12.19 21.5h-.01c-2.79-.02-4.94-.94-6.38-2.75C4.5 17.14 3.83 14.9 3.8 12.02v-.04c.03-2.88.7-5.12 1.99-6.73C7.24 3.44 9.39 2.52 12.18 2.5h.02c2.14.02 3.93.57 5.32 1.65 1.31 1.02 2.23 2.47 2.74 4.32l-1.76.49c-.86-3.08-3.03-4.65-6.31-4.68-2.16.02-3.8.7-4.86 2.03-1 1.25-1.51 3.05-1.53 5.36.02 2.31.53 4.11 1.53 5.37 1.06 1.33 2.7 2.01 4.86 2.03 1.95-.01 3.24-.47 4.31-1.53 1.23-1.22 1.21-2.72 1.21-3.6l.01-.32c-.65.4-1.5.63-2.53.66-1.86.05-3.86-.94-3.94-3.11-.05-1.28.67-3.24 3.74-3.32.99-.02 1.87.13 2.62.44-.13-1.08-.72-1.75-1.99-1.77-.87-.01-1.5.29-1.94 1.02l-1.5-.83c.86-1.42 2.19-1.99 3.47-1.97 2.36.03 3.66 1.5 3.79 4.1.07.05.15.1.22.16 1.03.96 1.79 2.41 1.9 4.17.22 3.61-2.17 6.05-6.31 6.08z" />
  </svg>
);

export const brandIcon = (name, props = {}) => {
  switch (name) {
    case 'tiktok':
      return <TikTokIcon {...props} />;
    case 'pinterest':
      return <PinterestIcon {...props} />;
    case 'threads':
      return <ThreadsIcon {...props} />;
    default:
      return null;
  }
};
